const GLOBAL_KEY = "documenttemplates";
const TOPIC_KEY = "topicdocumenttemplates";

const readList = (key: string): string[] => {
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed)
            ? parsed.filter((s): s is string => typeof s === "string")
            : [];
    } catch {
        return [];
    }
};

const readMap = (key: string): Record<string, string[]> => {
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
        return {};
    }
};

export const setStoredTemplate = (templateId: string | undefined): void => {
    if (templateId === undefined) return;
    const list = readList(GLOBAL_KEY);
    const next = [templateId, ...list.filter((id) => id !== templateId)].slice(
        0,
        10
    );
    localStorage.setItem(GLOBAL_KEY, JSON.stringify(next));
};

export const setStoredTopicTemplate = (
    topicId: string,
    templateId: string | undefined
): void => {
    if (templateId === undefined) return;
    const map = readMap(TOPIC_KEY);
    const existing = Array.isArray(map[topicId]) ? map[topicId] : [];
    map[topicId] = [
        templateId,
        ...existing.filter((id: string) => id !== templateId),
    ].slice(0, 10);
    localStorage.setItem(TOPIC_KEY, JSON.stringify(map));
};

/**
 * Returns the template that the user selected last for this topic, if it is
 * still available.
 */
export const getStoredTemplate = (
    topicId: string,
    availableIds: string[]
): string | undefined => {
    const map = readMap(TOPIC_KEY);
    const topicList = Array.isArray(map[topicId]) ? map[topicId] : [];
    return topicList.find(
        (id) => typeof id === "string" && availableIds.includes(id)
    );
};
